import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@components/ProtectedRoute';
import TvHiddenRoute from '@components/TvHiddenRoute';
import Login from '@pages/Login';
import StreamDashboard from '@pages/StreamDashboard';
import StreamPlayer from '@pages/StreamPlayer';
import StreamProviders from '@pages/StreamProviders';
import StreamMembers from '@pages/StreamMembers';
import Library from '@pages/Library';
import Movies from '@pages/Movies';
import Series from '@pages/Series';
import WatchHistory from '@pages/WatchHistory';
import Favorites from '@pages/Favorites';
import ProxyNodes from '@pages/ProxyNodes';
import Onboarding from '@pages/Onboarding';
import AdminDashboard from '@pages/AdminDashboard';
import AdminStreaming from '@pages/AdminStreaming';
import AdminAuditLog from '@pages/AdminAuditLog';
import AdminStatus from '@pages/AdminStatus';
import AdminChannelHealth from '@pages/AdminChannelHealth';
import AdminSupport from '@pages/AdminSupport';
import AcceptInvite from '@pages/AcceptInvite';
import HouseholdSettings from '@pages/HouseholdSettings';
import Pair from '@pages/Pair';
import TvPair from '@pages/TvPair';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* /invite/:token is intentionally NOT wrapped in ProtectedRoute —
          the page itself handles the unauthenticated case by redirecting
          to /login?next=... so the user can sign up and come back. */}
      <Route path="/invite/:token" element={<AcceptInvite />} />
      {/* /tv/pair is the TV-app login screen — never authed, since the
          whole point is that the TV doesn't have a session yet. */}
      <Route path="/tv/pair" element={<TvPair />} />
      {/* /pair is the phone-side approve flow — gated like every other
          authed route via ProtectedRoute (HouseholdGate would prompt
          to create a household if there isn't one, which is the right
          UX for a brand-new user pairing their first TV). */}
      <Route
        path="/pair"
        element={
          <ProtectedRoute>
            <Pair />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <StreamDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/watch/:channelId"
        element={
          <ProtectedRoute>
            <TvHiddenRoute>
              <StreamPlayer />
            </TvHiddenRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/providers"
        element={
          <ProtectedRoute>
            <StreamProviders />
          </ProtectedRoute>
        }
      />
      <Route
        path="/movies"
        element={
          <ProtectedRoute>
            <TvHiddenRoute>
              <Movies />
            </TvHiddenRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/series"
        element={
          <ProtectedRoute>
            <TvHiddenRoute>
              <Series />
            </TvHiddenRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/library"
        element={
          <ProtectedRoute>
            <TvHiddenRoute>
              <Library />
            </TvHiddenRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/members"
        element={
          <ProtectedRoute>
            <StreamMembers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <TvHiddenRoute>
              <WatchHistory />
            </TvHiddenRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/favorites"
        element={
          <ProtectedRoute>
            <TvHiddenRoute>
              <Favorites />
            </TvHiddenRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/proxy-nodes"
        element={
          <ProtectedRoute>
            <ProxyNodes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/cost"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/streaming"
        element={
          <ProtectedRoute>
            <AdminStreaming />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/status"
        element={
          <ProtectedRoute>
            <AdminStatus />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/channel-health"
        element={
          <ProtectedRoute>
            <AdminChannelHealth />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/audit"
        element={
          <ProtectedRoute>
            <AdminAuditLog />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/support/:householdId"
        element={
          <ProtectedRoute>
            <AdminSupport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/household"
        element={
          <ProtectedRoute>
            <HouseholdSettings />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
